/**
 * Tiny fuzzy-matcher voor zoek-velden in de UI (Concept Explorer,
 * Relations Panel, Type Palette). Geen dependency op een library —
 * de algoritme-keuze is bewust simpel: één-pass character-match die
 * "appcomp" → "Application Component" succesvol matcht maar niet zo
 * promiscuous wordt dat irrelevante resultaten bovenaan komen.
 *
 * Algoritme: walk de needle char-voor-char door de haystack. Elk
 * match-character mag verder vooruit liggen dan het vorige (skip
 * toegestaan), maar niet achteruit. Returnt true als alle needle-
 * chars in volgorde voorkomen.
 *
 * Case-insensitive. Lege needle = altijd match (toon alles).
 */
export function fuzzyMatch(haystack: string, needle: string): boolean {
  const n = needle.trim().toLowerCase();
  if (!n) return true;
  const h = haystack.toLowerCase();
  let hi = 0;
  for (let ni = 0; ni < n.length; ni++) {
    const ch = n[ni]!;
    let found = -1;
    for (let i = hi; i < h.length; i++) {
      if (h[i] === ch) {
        found = i;
        break;
      }
    }
    if (found === -1) return false;
    hi = found + 1;
  }
  return true;
}

/**
 * Match een needle tegen meerdere haystacks (bv. NL + EN naam). True
 * als één van de haystacks 'n fuzzy-match heeft.
 */
export function fuzzyMatchAny(haystacks: readonly string[], needle: string): boolean {
  if (!needle.trim()) return true;
  for (const h of haystacks) {
    if (fuzzyMatch(h, needle)) return true;
  }
  return false;
}
